import React from "react";
import { Box, Flex, Text, Avatar, Button } from "@chakra-ui/react";
import { Plus } from "lucide-react"; // Import an icon for the clock

const events = [
  {
    date: "24",
    month: "OCT",
    day: "THU",
    items: [
      {
        time: "10:00-11:00",
        title: "Teams call with Good Robot",
        color: "pink.50",
        textColor: "red.700",
        avatar: "https://firebasestorage.googleapis.com/v0/b/menu-digital---demo.appspot.com/o/user_images%2FGood-Robot-logo.png?alt=media&token=0b4e8817-0e71-4105-8e61-534742d56ef4",
      },
      {
        time: "12:00-12:30",
        title: "Meeting with Selena M.",
        color: "green.50",
        textColor: "green.700",
        avatar: "https://i.pravatar.cc/150?img=1",
      },
      {
        time: "16:00-16:30",
        title: "Meeting with Alec V.",
        color: "green.50",
        textColor: "green.700",
        avatar: "https://i.pravatar.cc/150?img=2",
      }
    ],
  },
  
];

const AgendaWidget = () => {
  return (
    <Flex 
      id="agenda"
      direction={"column"} 
      gap={{ lg: 8, base: 4 }}
      gridColumn={{ lg: "span 2", base: "span 6" }}
      >
      
      <Flex justify={"space-between"} w={"full"} align={"center"}> 
      <h5>Today's agenda</h5>
      <Button
        leftIcon={<Plus size={12}/>}
        size={"sm"}
        variant={"outline"}
      >Schedule</Button>
        
      </Flex>

    <Flex gap={4} direction={"column"}>
      {events.map((eventGroup) => (
          <Flex direction="column" gap={2} flex={1} key={eventGroup.date} >
            {eventGroup.items.map((item, idx) => (
              <Flex
                key={idx}
                w="full"
                gap={2}
                p={3}
                bg={item.color}
                borderRadius={16}
                align="center"
                justify={"center"}>
                {item.avatar && (
                  <Flex
                    border={"4px solid white"}
                    borderRadius="full"
                    align={"center"}
                    w={"40px"}
                    h={"40px"}>
                      <Avatar src={item.avatar} w={"32px"} h={"32px"} />
                  </Flex>
                )}
                {item.icon && 
                  <Flex 
                    border={"4px solid white"}
                    borderRadius="full"
                    justify={"center"}
                    align={"center"}
                    w={"40px"}
                    h={"40px"}
                    bg={item.textColor}
                    color={"white"}>
                      {item.icon}
                  </Flex>}
                <Box flex="1">
                  <Text fontWeight="500" color={item.textColor}>
                    {item.title}
                  </Text>
                  {item.time && (
                    <Text fontSize="sm" color="gray.700">
                      {item.time}
                    </Text>
                  )}
                </Box>
              </Flex>
            ))}
          </Flex>
      ))}
      </Flex>
    </Flex>
  );
};

export default AgendaWidget;
